<app-page-header icon="admin_panel_settings" title="Roles ·" highlight="{{ modoCreacion ? 'Nuevo' : 'Editar' }}" subtitle="{{ modoCreacion ? 'Crear un nuevo rol en el sistema' : 'Modificar los datos del rol' }}"></app-page-header>

<div class="seguridad-area seguridad-animate-in">
  <div class="container">
    <div class="barra-superior">
      <button mat-stroked-button class="btn-volver" (click)="cancelar()">
        <mat-icon>arrow_back</mat-icon> Volver
      </button>
    </div>

    <form [formGroup]="form" (ngSubmit)="guardar()" class="form-card">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Nombre del rol</mat-label>
        <input matInput formControlName="key" placeholder="Ej: ADMIN" autocomplete="off" />
        <mat-hint>Solo mayúsculas y guiones bajos</mat-hint>
        <mat-error *ngIf="form.get('key')?.hasError('required')">El nombre es obligatorio</mat-error>
        <mat-error *ngIf="form.get('key')?.hasError('pattern')">Solo se permiten mayúsculas y guiones bajos</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Descripción</mat-label>
        <input matInput formControlName="descripcion" placeholder="Descripción opcional del rol" autocomplete="off" />
      </mat-form-field>

      <div class="form-actions">
        <button mat-stroked-button class="btn-cancelar" type="button" (click)="cancelar()">Cancelar</button>
        <button mat-stroked-button class="btn-guardar" type="submit" [disabled]="form.invalid">
          {{ modoCreacion ? 'Crear rol' : 'Guardar cambios' }}
        </button>
      </div>
    </form>
  </div>
</div>
